<template>
  <div id="app">
    <div class="hero-image">
      <div class="hero-text">
        <p>
          <img src="/static/img/logo-putih.png" width="150" />
        </p>
        <h1>
          PRAKTEK TERBANG <br />& STUDI WISATA <br />
          PSPP PENERBANGAN
        </h1>
        <h3>BALI, 28 JUNI - 01 JULI 2021</h3>
      </div>
    </div>
    <div class="body">
      <h1>RUNDOWN</h1>
      <select
        style="width: 100%; padding: 10px; outline: none; margin-bottom: 20px"
        v-model="kampus"
      >
        <option value="JOGJA">PSPP Jogja</option>
        <option value="JAKARTA">PSPP Lampung & Jakarta</option>
        <option value="MAKASSAR">PSPP Makassar</option>
      </select>

      <jogja v-if="kampus == 'JOGJA'" />
      <makassar v-if="kampus == 'MAKASSAR'" />
      <lampung-jakarta v-if="kampus == 'JAKARTA'" />

    </div>
  </div>
</template>

<script>
import Jogja from "./components/Jogja.vue";
import Makassar from "./components/Makassar.vue";
import LampungJakarta from "./components/LampungJakarta.vue";

export default {
  name: "app",
  components: {
    Jogja,
    Makassar,
    LampungJakarta,
  },
  data() {
    return {
      kampus: "JOGJA",
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");
* {
  font-family: "Montserrat", sans-serif;
}
html,
body {
  margin: 0;
  height: 100%;
}

.hero-image {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("https://images.pexels.com/photos/3762977/pexels-photo-3762977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  width: 100%;
  height: 100vh;

  /* Position and center the image to scale nicely on all screens */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero-text {
  text-align: center;
  color: white;
}
.hero-text h1 {
  margin: 15px;
  font-size: 28px;
}
.body {
  padding: 15px;
}
.kampus {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
}
.kampus a {
  text-decoration: none;
  text-align: center;
  color: #333;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue